import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { USER } from 'sh-www/models/user';
import { set } from '@ember/object';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

class SignupStepVerifyRoute extends Route {
  @service router;
  @service session;

  redirect() {
    if (this.session.currentUser.signupStep !== USER.SELLER_SIGNUP_STEPS.VALIDATE_EMAIL) {
      this.router.replaceWith('signup.step.profile');
    }
  }

  activate(transition) {
    super.activate(...arguments);

    set(
      this.controllerFor('signup.step'),
      'signupStep',
      USER.SELLER_SIGNUP_STEPS.VALIDATE_EMAIL,
    );

    trackPageViewFromTransition(this, transition, '/signup/step/verify/');
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.resendVerificationEmail.cancelAll({ resetState: true });
    }
  }
}

export default SignupStepVerifyRoute;
